import HorizontalLayout from 'Container/HorizontalLayout'

const Home = () => import('Views/Home/index')

const Students = () => import('Views/Students')
const StudentProfile = () => import('Views/Students/Profile')
const Instructors = () => import('Views/Instructors')
const InstructorProfile = () => import('Views/Instructors/Profile')
const Faculty = () => import('Views/faculties')
const Courses = () => import('Views/courses')
const Programs = () => import('Views/programs')
const Semesters = () => import('Views/semesters')

const Admins = () => import('Views/Admins')
const profileSettings = () => import('Views/Admins/profileSettings')

// Instructor Views
const InsProfile = () => import('Views/InstructorViews/Profile/')
const Ins_courseStudents = () => import('Views/InstructorViews/StudentCourses/')

// Students Views
const Stu_Profile = () => import('Views/StudentViews/Profile/')


 
export default {
    path: '/',
    component: HorizontalLayout,
    redirect: '/admins',
    children: [
        {
            path: '/',
            component: Home,
            name: 'Home',
            meta: {
                requiresAuth: true,
                title: 'Home',
                breadcrumb: [
                    {
                        breadcrumbActive: 'Home'
                    }
                ]
            }
        },
  
        {
            path: '/admins',
            component: Admins,
            name: 'Admins',
            meta: {
                requiresAuth: true,
                title: 'Admins',
                breadcrumb: [
                    {
                        breadcrumbActive: 'Admins'
                    }
                ]
            }
        },
      
        {
            path: '/students',
            component: Students,
            name: 'Students',
            meta: {
                requiresAuth: true,
                title: 'Students',
                breadcrumb: [
                    {
                        breadcrumbActive: 'Students'
                    }
                ]
            }
        },
        {
            path: '/students/:id',
            component: StudentProfile,
            name: 'StudentProfile',
            meta: {
                requiresAuth: true,
                title: 'Student Profile',
                breadcrumb: [
                    {
                        breadcrumbActive: 'Student Profile'
                    }
                ]
            }
        },
        {
            path: '/course/:id/students',
            component: Students,
            name: 'CourseStudents',
            meta: {
                requiresAuth: true,
                title: 'Students',
                breadcrumb: [
                    {
                        breadcrumbActive: 'Students'
                    }
                ]
            }
        },
        
        // {
        //     path: '/students/:id',
        //     component: Student,
        //     name: 'Student',
        //     meta: {
        //         requiresAuth: true,
        //         title: 'Student',
        //         breadcrumb: [
        //             {
        //                 breadcrumbActive: 'Student'
        //             }
        //         ]
        //     }
        // },
        {
            path: '/programs',
            component: Programs,
            name: 'Programs',
            meta: {
                requiresAuth: true,
                title: 'Programs',
                breadcrumb: [
                    {
                        breadcrumbActive: 'Programs'
                    }
                ]
            }
        },
        {
            path: '/semesters',
            component: Semesters,
            name: 'Semesters',
            meta: {
                requiresAuth: true,
                title: 'Semesters',
                breadcrumb: [
                    {
                        breadcrumbActive: 'Semesters'
                    }
                ]
            }
        },
        {
            path: '/instructors',
            component: Instructors,
            name: 'Instructors',
            meta: {
                requiresAuth: true,
                title: 'Instructors',
                breadcrumb: [
                    {
                        breadcrumbActive: 'Instructors'
                    }
                ]
            }
        },
        {
            path: '/instructors/:id',
            component: InstructorProfile,
            name: 'InstructorProfile',
            meta: {
                requiresAuth: true,
                title: 'Instructor Profile',
                breadcrumb: [
                    {
                        breadcrumbActive: 'Instructor Profile'
                    }
                ]
            }
        },
        
        {
            path: '/faculty',
            component: Faculty,
            name: 'Faculty',
            meta: {
                requiresAuth: true,
                title: 'Faculty',
                breadcrumb: [
                    {
                        breadcrumbActive: 'Faculty'
                    }
                ]
            }
        },
        {
            path: '/courses',
            component: Courses,
            name: 'Courses',
            meta: {
                requiresAuth: true,
                title: 'Courses',
                breadcrumb: [
                    {
                        breadcrumbActive: 'Courses'
                    }
                ]
            }
        },
     


        {
            path: '/profile-settings',
            component: profileSettings,
            name: 'profileSettings',
            meta: {
                requiresAuth: true,
                title: 'Edit Account Settings',
                breadcrumb: [
                    {
                        breadcrumbActive: 'Edit Profile'
                    }
                ]
            }
        },


        // Instructor Routes
        {
            path: '/instructor/profile',
            component: InsProfile,
            name: 'InsProfile',
            meta: {
                requiresAuth: true,
                title: 'Instructor Profile',
                breadcrumb: [
                    {
                        breadcrumbActive: 'Instructor Profile'
                    }
                ]
            }
        },
        {
            path: '/instructor/course/:id',
            component: Ins_courseStudents,
            name: 'Ins_courseStudents',
            meta: {
                requiresAuth: true,
                title: 'Course Students',
                breadcrumb: [
                    {
                        breadcrumbActive: 'Course Students'
                    }
                ]
            }
        },



        // Students Routes
        {
            path: '/student/profile/:id?',
            component: Stu_Profile,
            name: 'Stu_Profile',
            meta: {
                requiresAuth: true,
                title: 'Student Profile',
                breadcrumb: [
                    {
                        breadcrumbActive: 'Student Profile'
                    }
                ]
            }
        },





    ]
}
